import { createFileRoute } from "@tanstack/react-router";

import { authQueries } from "@/api/resources/auth/queries";
import { workspaceInvitationsQueries } from "@/api/resources/workspaceInvitations/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import OnboardingPage from "@/components/Onboarding/OnboardingPage";

export const Route = createFileRoute("/_auth/welcome")({
  loader: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(authQueries.getAuthSession());
    const profile = await context.queryClient.ensureQueryData(authQueries.getAuthUserProfile(session?.user.id));
    await context.queryClient.ensureQueryData(workspacesQueries.listAll());

    if (profile) {
      await context.queryClient.ensureQueryData(workspaceInvitationsQueries.listInvited(profile.email));
    }
  },
  component: OnboardingPage,
});
